import React, { Component, memo } from "react"
import PropTypes from "prop-types";
import MetaTags from 'react-meta-tags';
import { Container, Row, Col } from "reactstrap"
import { connect } from "react-redux"

//Import Breadcrumb
import "../../pages/pages.scss"

import { withTranslation } from "react-i18next";
import { Helmet } from "react-helmet";

// Import helpers and components
import DecoderForm from "./DecoderForm";
import DecoderResults from "./DecoderResults";
import ErrorMessage from "../Common/ErrorMessage";
import { getTemplateConfig } from "../../config/decoderTemplates";

// Redux actions
import {
  decodeRequest,
  updateHexValue,
  clearDecoderState,
  toggleBit,
  setDecoderType,
  initializeWithDefault
} from "../../store/actions"

class GenericDecoder extends Component {
  constructor(props) {
    super(props)
    
    this.templateConfig = getTemplateConfig(this.props.location.pathname);
  }

  componentDidMount() {
    if (this.templateConfig?.pageKey) {
      this.props.setDecoderType(this.templateConfig.pageKey)
      
      if (this.templateConfig.defaultValue && 
          !this.props.responseCache[this.templateConfig.pageKey]) {
        if (this.templateConfig.skipInitialRequest && 
            this.templateConfig.defaultValue.match(/^0+$/)) {
          this.props.updateHexValue(this.templateConfig.defaultValue)
        } else {
          this.props.initializeWithDefault(
            this.templateConfig.defaultValue,
            this.templateConfig.endpoint,
            this.templateConfig.pageKey
          )
        }
      } else if (this.props.responseCache[this.templateConfig.pageKey]) {
        if (this.templateConfig.defaultValue) {
          this.props.updateHexValue(this.templateConfig.defaultValue)
        }
      }
    }
  }

  componentWillUnmount() {
    this.props.clearDecoderState()
  }

  handleValidSubmit = (e, values) => {
    if (!this.templateConfig) return
    
    this.props.updateHexValue(values.data)
    
    this.props.decodeRequest(
      values.data,
      this.templateConfig.endpoint,
      this.templateConfig.pageKey
    )
  }

  processMatrixData = (resultData) => {
    if (!resultData?.matrixData.bytes) return null;
    
    return JSON.parse(JSON.stringify(resultData.matrixData.bytes));
  }

  handleBitToggle = (byteIndex, bitPosition, currentValue) => {
    if (!this.templateConfig?.hasMatrix) return;

    this.props.toggleBit(
      byteIndex,
      bitPosition,
      currentValue,
      this.props.currentHexValue,
      this.templateConfig.pageKey
    )
  }

  dataChange = (event) => {
    const hexValue = event.target.value
    this.props.updateHexValue(hexValue)
  }

  handleClear = () => {
    this.props.clearDecoderState()
  }

  render() {
    if (!this.templateConfig) {
      return <div>Template configuration not found for this route.</div>
    }

    return (
      <React.Fragment>
      <div className="general-wrapper" style={{ 
        paddingTop: '5.5rem',
        paddingLeft: '2rem', 
        paddingBottom: '3rem' , 
        paddingRight: '2rem', 
        backgroundColor:'#ffffff' ,
        border: 'none',
        boxShadow: 'none',
        minHeight: '95vh'
        }}>
        <Helmet>
        <MetaTags>
          <title>{this.templateConfig.metaTags?.title}</title>
          <meta name="description" content={this.templateConfig.metaTags?.description} />
          <meta name="keywords" content={this.templateConfig.metaTags?.keywords} />
        </MetaTags>
        </Helmet>

        <Container fluid>
          <Row style={{maxWidth: 'fit-content'}}>
            <Col xs="12">
              <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                <h4 className="mb-0 font-size-18">{this.props.t(this.templateConfig.breadcrumbItem)}</h4>
              </div>
            </Col>
          </Row>
          <div className="mb-3 text-muted" style={{maxWidth: 'fit-content'}}>
            {this.props.t(this.templateConfig.infoText)}
          </div>
          
          <Col className="mt-4">
            <DecoderForm
            templateConfig={this.templateConfig}
            onValidSubmit={this.handleValidSubmit}
            onDataChange={this.dataChange}
            onClear={this.handleClear}
            buttonTimer={this.props.buttonTimer}
            dataLength={this.props.dataLength}
            showLengthBadge={this.props.showLengthBadge}
            currentHexValue={this.props.currentHexValue}
            />
            <ErrorMessage 
              error={this.props.error}
              title={this.props.t("decodeOperationFailed")}
            />
            <DecoderResults
            apiResponse={this.props.apiResponse}
            localMatrixData={this.props.localMatrixData}
            templateConfig={this.templateConfig}
            onBitToggle={this.handleBitToggle}
            currentHexValue={this.props.currentHexValue}
            />
          </Col>
        </Container>
      </div>
      </React.Fragment>
    )
  }
}

GenericDecoder.propTypes = {
  t: PropTypes.any,
  location: PropTypes.object.isRequired,
  buttonTimer: PropTypes.bool,
  apiResponse: PropTypes.object,
  currentHexValue: PropTypes.string,
  dataLength: PropTypes.number,
  showLengthBadge: PropTypes.bool,
  localMatrixData: PropTypes.object,
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  responseCache: PropTypes.object,
  decodeRequest: PropTypes.func.isRequired,
  updateHexValue: PropTypes.func.isRequired,
  clearDecoderState: PropTypes.func.isRequired,
  toggleBit: PropTypes.func.isRequired,
  setDecoderType: PropTypes.func.isRequired,
  initializeWithDefault: PropTypes.func.isRequired,
}

const mapStateToProps = state => {
  const decoder = state.decoder
  return {
    buttonTimer: decoder.buttonTimer,
    apiResponse: decoder.apiResponse,
    currentHexValue: decoder.currentHexValue,
    dataLength: decoder.dataLength,
    showLengthBadge: decoder.showLengthBadge,
    localMatrixData: decoder.localMatrixData,
    isLoading: decoder.isLoading,
    error: decoder.error,
    responseCache: decoder.responseCache,
  }
}

const mapDispatchToProps = {
  decodeRequest,
  updateHexValue,
  clearDecoderState,
  toggleBit,
  setDecoderType,
  initializeWithDefault
}

export default memo(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(GenericDecoder)))
